export function mediaMatrixSessionCompletedEvent<T extends string>(serviceType: T) {
  return {
    studio: {
      studioMediaMatrix: {
        sessionCompleted: {
          serviceType,
        },
      },
    },
  }
}

export function mediaMatrixContentProcessedEvent<T extends string>(serviceType: T) {
  return {
    studio: {
      studioMediaMatrix: {
        contentProcessedBroadcastEvent: {
          serviceType,
        },
      },
    },
  }
}
